module.exports = __webpack_public_path__ + "static/media/top_img_hub.adf9faec.png";